import { HeadingBlockProps } from '@design-system/heading-block';

import TMPLinkWrap from '~/components/TMPLinkWrap';
import { buttonWithLinkMapper } from '~/mappers/button';
import { ctaBlockMapper } from '~/mappers/ctaBlock';
import { optionalLinkMapper } from '~/mappers/link';

import { HeadingBlock, HeadingBlockUI } from './models';

// eslint-disable-next-line complexity
const headingBlockUIMapper = (uiBlock?: { ui: HeadingBlockUI }) => {
  if (!uiBlock) return undefined;

  const {
    ui: {
      align,
      descriptionVariant,
      headlineTag,
      headlineVariant,
      descriptionSize,
      descriptionWeight,
      headlineSize,
      headlineWeight,
      detailVariant,
      detailSize,
      detailWeight,
      wrapping,
    },
  } = uiBlock;

  return {
    ...(align && { align }),
    ...(descriptionVariant && { descriptionVariant }),
    ...(headlineTag && { headlineTag }),
    ...(detailVariant && { detailVariant }),
    ...(detailWeight && { detailWeight }),
    ...(detailSize && { detailSize }),
    ...(headlineVariant && { headlineVariant }),
    ...(wrapping && { wrapping }),
    ...(descriptionSize && { descriptionSize }),
    ...(descriptionWeight && { descriptionWeight }),
    ...(headlineSize && { headlineSize }),
    ...(headlineWeight && { headlineWeight }),
  };
};

export const headingBlockMapper = ({
  ui: [ui],
  descriptionRte,
  headline,
  detail,
  button,
  link,
  ctaBlocks,
}: HeadingBlock): HeadingBlockProps | null => {
  if (!headline && !descriptionRte && !detail) return null;
  const mappedLinks = optionalLinkMapper(link);

  return {
    ...(detail && { detail }),
    ...(headline && { headline }),
    ...(descriptionRte && { description: descriptionRte }),
    ...headingBlockUIMapper(ui),
    ...(button?.[0]?.link?.href.length && {
      headlineButton: buttonWithLinkMapper(button[0]),
    }),
    ...(mappedLinks && {
      headlineLink: { component: TMPLinkWrap, props: mappedLinks },
    }),
    ...(ctaBlocks?.length && { ctaBlock: ctaBlockMapper(ctaBlocks) }),
  } as HeadingBlockProps;
};
